module.exports = __webpack_public_path__ + "static/media/dark-resource-tag.5e32bef0.svg";